import React from "react";
import CorporateSignupForm from "./CorporateSignupForm";

function CorporateSignupPage() {
  return <CorporateSignupForm />;
}

export default CorporateSignupPage;
